import { render, staticRenderFns } from "./PsEventDialog.vue?vue&type=template&id=0e9d43be&scoped=true&"
import script from "./PsEventDialog.vue?vue&type=script&lang=js&"
export * from "./PsEventDialog.vue?vue&type=script&lang=js&"
import style0 from "./PsEventDialog.vue?vue&type=style&index=0&id=0e9d43be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9d43be",
  null
  
)

export default component.exports